import sanityClient from '../client';
import ImageUrlBuilder from '@sanity/image-url';

const builder = ImageUrlBuilder(sanityClient);

export const urlFor = (source) => {
    return builder.image(source).auto('format').quality(80).fit('max');
};
